<div class="editor-tag" *ngIf="items && items.length > 0">
  <div class="remove-all-tag" (click)="clearAll()">x</div>
  <div class="tag-item" *ngFor="let item of items">
    <small *ngIf="isValidDate(item.title)">
      {{ item.title | persianDate }}
    </small>
    <small *ngIf="isValidNumber(item.title)">
      {{ item.title }}
    </small>
    <small *ngIf="!isValidNumber(item.title) && !isValidDate(item.title)">
      {{ item.title }}
    </small>
    <div class="remove-tag" (click)="changed(item)">×</div>
  </div>
</div>